import * as React from "react";
import { gql, useQuery } from "@apollo/client";
import {
  ViewUserQuery,
  ViewUserQueryVariables,
} from "../../schemaTypes";

export const viewUserQuery = gql`
  query ViewUser($id: String!) {
    viewUser(id: $id) {
      ... on CustomerPWA {
        __typename
        id
        avatarUrl
        firstname
        lastname
        email
        username
        phone
        createdAt
        updatedAt
      }
      ... on AdminPWA {
        __typename
        id
        merchantProfile {
          id
          companyName
          username
          companyLocation
          logoUrl
          bannerUrl
          description
        }
      }
      ... on ErrorType {
        __typename
        errors {
          path
          message
        }
      }
    }
  }
`;

export interface WithViewUser {
  user: ViewUserQuery["viewUser"] | null;
  loading: boolean;
  error?: { path: string; message: string }[] | null;
}

interface Props {
  userId: string;
  children: (data: WithViewUser) => React.ReactElement | null;
}

export const ViewUser: React.FC<Props> = ({ userId, children }) => {
  const { data, loading } = useQuery<
    ViewUserQuery, 
    ViewUserQueryVariables
  >(viewUserQuery, {
    variables: { id: userId }
  });

  let user: ViewUserQuery["viewUser"] | null = null;
  let error: { path: string; message: string }[] | null = null;

  if (data && data.viewUser) {
    if (
      typeof data.viewUser === "object" &&
      data.viewUser !== null &&
      "__typename" in data.viewUser &&
      (data.viewUser as { __typename?: string }).__typename === "ErrorType"
    ) {
      error = ((data.viewUser as unknown) as { errors: { path: string; message: string }[] }).errors;
    } else {
      user = data.viewUser;
    }
  }

  return children({
    user,
    loading,
    error,
  });
};